import { AVTO } from './search/avto';

import { MOTO } from './search/moto';

import { MOTOTSIKL } from './search/mototsikl';

import { SKUTER } from './search/skuter';

import { MOPED } from './search/moped';

import { KVADROTSIKL } from './search/kvadrotsikl';

import { BAGGI } from './search/baggi';

import { TRITSIKL } from './search/tritsikl';

import { AVTO as AVTOSALONY_AVTO } from './avtosalony/avto';
import { GRUZOVYE as AVTOSALONY_GRUZOVYE } from './avtosalony/gruzovye';
import { AVTOBUS as AVTOSALONY_AVTOBUS } from './avtosalony/avtobus';
import { VODNYI_TRANSPORT as AVTOSALONY_VODNYI_TRANSPORT } from './avtosalony/vodnyi-transport';
import { MOTOTSIKL as AVTOSALONY_MOTOTSIKL } from './avtosalony/mototsikl';
import { PRITSEPY as AVTOSALONY_PRITSEPY } from './avtosalony/pritsepy';
import { SPETSTEHNIKA as AVTOSALONY_SPETSTEHNIKA } from './avtosalony/spetstehnika';

import {
  AUTO as ZAPCHASTI_AVTO,
  AVTO_DVIGATEL_MAHOVIK as ZAPCHASTI_AVTO_DVIGATEL_MAHOVIK,
  AVTO_DVIGATEL_PATRUBKI as ZAPCHASTI_AVTO_DVIGATEL_PATRUBKI,
  AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI as ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
  AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS as ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
  AVTO_DVIGATEL_KLAPANI__EGR as ZAPCHASTI_AVTO_DVIGATEL_KLAPANI__EGR,
} from './zapchasti/avto';

import { AVTOBUS as ZAPCHASTI_AVTOBUS } from './zapchasti/avtobus';
import { GRUZOVYE as ZAPCHASTI_GRUZOVYE } from './zapchasti/gruzovye';
import { MOTO as ZAPCHASTI_MOTO } from './zapchasti/moto';
import { SKUTER as ZAPCHASTI_SKUTER } from './zapchasti/skuter';
import { MOTOTSIKL as ZAPCHASTI_MOTOTSIKL } from './zapchasti/mototsikl';
import { KVADROTSIKL as ZAPCHASTI_KVADROTSIKL } from './zapchasti/kvadrotsikl';
import { MOPED as ZAPCHASTI_MOPED } from './zapchasti/moped';
import { SPETSTEHNIKA as ZAPCHASTI_SPETSTEHNIKA } from './zapchasti/spetstehnika';
import { PRITSEPY as ZAPCHASTI_PRITSEPY } from './zapchasti/pritsepy';
import { TRITSIKL as ZAPCHASTI_TRITSIKL} from './zapchasti/tritsikl';
import { VODNYI_TRANSPORT as ZAPCHASTI_VODNYI_TRANSPORT } from './zapchasti/vodnyi-transport';

import { COMMERCIAL_GRUZOVYE } from './commercial/gruzovye';

export default {
  AVTO,
  MOTO,
  MOTOTSIKL,
  SKUTER,
  KVADROTSIKL,
  MOPED,
  BAGGI,
  TRITSIKL,

  AVTOSALONY_AVTO,
  AVTOSALONY_GRUZOVYE,
  AVTOSALONY_AVTOBUS,
  AVTOSALONY_VODNYI_TRANSPORT,
  AVTOSALONY_MOTOTSIKL,
  AVTOSALONY_PRITSEPY,
  AVTOSALONY_SPETSTEHNIKA,

  ZAPCHASTI_AVTO,
  ZAPCHASTI_MOTO,
  ZAPCHASTI_AVTOBUS,
  ZAPCHASTI_PRITSEPY,
  ZAPCHASTI_GRUZOVYE,
  ZAPCHASTI_TRITSIKL,
  ZAPCHASTI_SPETSTEHNIKA,
  ZAPCHASTI_VODNYI_TRANSPORT,

  ZAPCHASTI_AVTO_DVIGATEL_MAHOVIK,

  ZAPCHASTI_AVTO_DVIGATEL_PATRUBKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
  ZAPCHASTI_AVTO_DVIGATEL_KLAPANI__EGR,

  ZAPCHASTI_SKUTER,
  ZAPCHASTI_MOTOTSIKL,
  ZAPCHASTI_KVADROTSIKL,
  ZAPCHASTI_MOPED,

  COMMERCIAL_GRUZOVYE,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/index.js